<template>
  <div class="we-side-bar">
    <!--  <we-navbar
      ref="navbar"
      :nav-list="navList"
      :add-title="$t('message.newNavBar.createdTitle')"
      @on-add="openAddTab"
      @on-refresh="reflesh"
      @text-change="setSearchText"
    /> -->
    <div class="overlap">
      <Input
        class="overlapItem top"
        clearable
        v-model="searchText"
        search
        @on-change="filterTree"
        @on-enter="filterTreeByKey"
        placeholder="请输入关键字查询~"
      >
      </Input>
      <Select
        class="overlapItem"
        ref="searchOption"
        v-model="searchValue"
        filterable
        clearable
        @on-select="filterTreeByTypeAndId"
        :label-in-value="true"
      >
        <Option
          v-for="(option) in filterList"
          :value="option.id"
          :key="option.id"
          >{{ option.name }}</Option
        >
      </Select>
    </div>
    <!-- <Select
      v-model="searchText"
      filterable
      clearable
      :remote-method="filterTree"
      :loading="filterLoading"
      @on-select="filterTreeByTypeAndId"
      :label-in-value="true"
      @keyup.enter.native="filterTreeByKey"
      placeholder="请输入关键字查询~"
    >
      <Option
        v-for="(option, index) in filterList"
        :value="option.id"
        :key="option.id"
      >{{ option.name }}</Option>
    </Select> -->
    <Select
      class="datasource"
      v-model="dataSourceId"
      style="margintop: 5px"
      filterable
      clearable
      placeholder="请选择要查询的数据源~"
      @on-select="filterTreeByDataSourceId"
    >
      <Option value="all" key="all">所有数据源</Option>
      <Option v-for="item in dataSourceList" :value="item.id" :key="item.id">
        {{ item.name }}</Option
      >
    </Select>
    <Spin v-if="isPending" size="large" fix />
    <!-- <div class="tree"> -->
    <Alert
      type="warning"
      v-if="tableList.length == 0 && !isPending"
      class="verticalMiddle"
      >搜索结果为空~</Alert
    >
    <Scroll :on-reach-bottom="handleReachBottom">
      <we-hive-list
        :data="tableList"
        :filter-text="searchText"
        :loading="isPending"
        class="we-side-bar-content v-hivedb-list"
        @we-click="onClick"
        @we-contextmenu="onContextMenu"
        @we-dblclick="handledbclick"
      />
    </Scroll>
    <!--  </div> -->
    <we-menu ref="contextMenu" id="hive">
      <template v-if="currentType === 'db'">
        <we-menu-item @select="copyName">{{
          $t("message.database.contextMenu.db.copyName")
        }}</we-menu-item>
        <we-menu-item @select="pasteName">{{
          $t("message.database.contextMenu.db.pasteName")
        }}</we-menu-item>
        <we-menu-item class="ctx-divider" />
        <we-menu-item @select="reflesh">{{
          $t("message.constants.refresh")
        }}</we-menu-item>
      </template>
      <template v-if="currentType === 'tb'">
        <we-menu-item @select="queryTable" v-if="!model">{{
          $t("message.database.contextMenu.tb.queryTable")
        }}</we-menu-item>
        <!-- <we-menu-item @select="openDeleteDialog" v-if="!model">{{
          $t("message.database.contextMenu.tb.deleteTable")
        }}</we-menu-item> -->
        <we-menu-item @select="describeTable">{{
          $t("message.database.contextMenu.tb.viewTable")
        }}</we-menu-item>
        <we-menu-item @select="applyRight">{{
          $t("message.database.contextMenu.tb.applyRight")
        }}</we-menu-item>
        <!-- <we-menu-item
          v-if="isAllowToExport && !model"
        @select="openExportDialog">{{ $t('message.database.contextMenu.tb.exportTable') }}</we-menu-item>-->
        <we-menu-item class="ctx-divider" />
        <we-menu-item @select="copyName">{{
          $t("message.database.contextMenu.tb.copyName")
        }}</we-menu-item>
        <we-menu-item @select="pasteName">{{
          $t("message.database.contextMenu.tb.pasteName")
        }}</we-menu-item>
        <we-menu-item @select="copyAllColumns">{{
          $t("message.database.contextMenu.tb.copyAllColumns")
        }}</we-menu-item>
        <we-menu-item class="ctx-divider" />
        <we-menu-item @select="reflesh">{{
          $t("message.constants.refresh")
        }}</we-menu-item>
      </template>
      <template v-if="currentType === 'field'">
        <we-menu-item @select="copyName">{{
          $t("message.database.contextMenu.field.copyColumnsName")
        }}</we-menu-item>
        <we-menu-item @select="pasteName">{{
          $t("message.database.contextMenu.field.pasteName")
        }}</we-menu-item>
      </template>
    </we-menu>
    <we-hive-table-export
      ref="exportDialog"
      :width="490"
      :table-detail="currentAcitved"
      :db-list="filterDbList"
      :tree="fileTree"
      :load-data-fn="loadDataFn"
      :filter-node="filterNode"
      @get-columns="asyncGetTableColumns"
      @get-tables="getTables"
      @get-tree="getFileTree"
      @get-partitions="getPartitions"
      @get-size="getPartitionsSize"
      @export="exportTable"
    />
    <applyRightDialog ref="applyRightDialog" :columnDatas="columnDatas" />
    <delete-dialog
      ref="deleteDialog"
      :loading="isDeleting"
      @delete="deleteTable"
    />
  </div>
</template>
<script>
import { isEmpty, map, find, cloneDeep, debounce } from "lodash";
import storage from "@dss/js/helper/storage";
import api from "@dss/js/service/api";
import util from "@dss/js/util";
import weHiveList from "@dss/js/component/hiveList";
import WeHiveTableExport from "@dss/js/component/hiveTableExport";
import deleteDialog from "@dss/js/component/deleteDialog";
import applyRightDialog from "@dss/js/component/applyRightDialog";
import { axios, WORKSPACEIDKEY, NODE_ENV } from "@/api";
export default {
  name: "HiveSidebar",
  components: {
    weHiveList,
    WeHiveTableExport,
    deleteDialog,
    applyRightDialog,
  },
  props: {
    model: String,
    node: Object,
    sqlCode: String,
    resIdProp: String,
    resType: String,
  },
  data() {
    return {
      //navList: ["search", "refresh"], //'newFile',
      dataSourceType: "",
      searchText: "",
      searchValue: "",
      filterLoading: false,
      filterList: [],
      currentType: "",
      tableList: [],
      filterDbList: [],
      currentAcitved: null,
      isPending: false,
      fileTree: [],
      isDeleting: false,
      loadDataFn: () => {},
      // 用于避免双击和单击的冲突
      dblClickTimer: null,
      columnDatas: [],
      dataSourceId: "all",
      dataSourceList: [],
      pageNum: 1,
      onEnter: false,
    };
  },
  computed: {
    isAllowToExport() {
      return this.currentAcitved && this.currentAcitved.dataType === "tb";
    },
  },
  watch: {
    currentAcitved(val) {
      if (val) {
        let item = val.id.split("@");
        this.dataSourceId = `${item[0]}@${item[1]}`;
      }
    },
  },
  mounted() {
    this.initData();
    this.getDataSourceList();
  },
  beforeDestroy() {},
  methods: {
    async getTableData(queryType, params) {
      
      params.workspace = storage.get(WORKSPACEIDKEY, "cookie");
      params.type = this.dataSourceType;
      if (!params.pageNum) {
        params.pageNum = this.pageNum;
      }
      let { data } = await axios({
        method: "get",
        url: `/api/rest_j/v1/metadata/v1/getAuthTreeByResId`,
        params,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        transformRequest: [
          function (data, headers) {
            return JSON.stringify(data);
          },
        ],
      });
      this.isPending = false;
      this.filterLoading = false;
      data = data?.list || [];
      switch (queryType) {
        case "init":
          //初始化，只展示200条表数据
          this.tableList = data.slice(0, 200).map((item) => {
            item.iconCls = "fi-table";
            item.dataType = "tb";
            item.isOpen = false;
            item.children = [];
            item.isVisible = true;
            return item;
          });
          break;
        case "initAdd":
          // //向下滚动触底时，再添加两百条
          // this.tableList.concat(data.map((item) => {
          //   item.iconCls = "fi-table";
          //   item.dataType = "tb";
          //   item.isOpen = false;
          //   item.children= [];
          //   item.isVisible = true;
          //   return item;
          // }));
          this.tableList = data.slice(0, params.pageNum * 200).map((item) => {
            item.iconCls = "fi-table";
            item.dataType = "tb";
            item.isOpen = false;
            item.children = [];
            item.isVisible = true;
            return item;
          });
          break;
        case "queryOptions":
          //根据关键字查询下拉选项
          const leafTypes = { datasource: "源", schema: "库", table: "表" };
          this.filterList = data.map((item) => ({
            id: `${item.leafType}&${item.id}`,
            name: `[${leafTypes[item.leafType]}] ${item.name}`,
            leafType: item.leafType,
          }));
          this.$refs["searchOption"].toggleMenu();
          break;
        case "queryTable":
          //输入关键字直接回车，按表查询
          this.buildTree(data, "tables", false);
          this.onEnter = false;
          break;
        case "selectOption":
          //选了搜索下拉项的某一条或者选了数据源
          this.buildTree(data, params.leaftype, true);
      }
    },
    async buildTree(data, leaftype, setDataSource) {
      if (leaftype == "table") {
        let db, tb;
        for (const d of data) {
          switch (d.leafType) {
            case "datasource":
              this.dataSourceId = d.id;
              break;
            case "schema":
              db = {
                ...d,
                dataType: "db",
                isOpen: true,
                isVisible: true,
                children: [],
                iconCls: "fi-hivedb",
              };
              break;
            case "table":
              await this.getTableColumns(d, true);
              d.iconCls = "fi-table";
              d.dataType = "tb";
              d.isOpen = true;
              d.isVisible = true;
              tb = d;
              break;
          }
        }
        db.children.push(tb);
        this.tableList = [db];
      } else {
        let list = [];
        let nodeMap = new Map();

        data.forEach((n) => {
          if (n.leafType == "table") {
            let children = nodeMap.get(n.pid) || [];
            children.push({
              ...n,
              dataType: "tb",
              isOpen: false,
              isVisible: true,
              children: [],
              iconCls: "fi-table",
            });
            nodeMap.set(n.pid, children);
          } else if (n.leafType == "schema") {
            list.push({
              ...n,
              dataType: "db",
              isOpen: leaftype == "datasource" ? false : true,
              isVisible: true,
              children: [],
              iconCls: "fi-hivedb",
            });
          } else if (setDataSource) {
            this.dataSourceId = n.id;
          }
        });
        this.tableList = list.map((item) => {
          item.children = nodeMap.get(item.id);
          return item;
        });
      }
    },
    getDBCls(leafType) {
      return {
        datasource: "fi-folder",
        schema: "fi-hivedb",
        table: "fi-table",
      }[leafType];
    },
    handleReachBottom() {
      if (
        this.searchText != "" ||
        this.filterList.length !==0 ||
        this.dataSourceId != "all"
      ) {
        return;
      }
      this.pageNum = this.pageNum + 1;
      this.getTableData("initAdd", { pageNum: this.pageNum });
    },
    async initData() {
      this.sendTrack([{ pageId: 22, buttonId: 139, type: "show" }]);
      this.isPending = true;
      let dataSourceType = "hive,mysql,rds,gp,es,clickhouse,doris";
      if (this.node && this.node.type) {
        if (
          this.node.type.endsWith("hive.hql") ||
          this.node.type.endsWith("spark.sql")
        ) {
          dataSourceType = "hive";
        }
        if (this.node.type.endsWith("jdbc")) {
          dataSourceType = "mysql,rds,gp,es";
        }
      }
      this.dataSourceType = dataSourceType;
      //根据租户Id获取当前用户有权限的数据库，分两次，第一次获取的是库表信息，第二次（点击表名时）获取字段信息
      //if (!hiveList || isEmpty(hiveList)) {
      this.getTableData("init", { type: dataSourceType });

      // if (!this.node) {
      //   this.initDefaultTab();
      // }
      //从找数据处跳转过来的
      //this.queryTableWithCode();
    },
    getDataSourceList() {
      axios
        .get(`/api/rest_j/v1/metadata/v1/getAllDBSource?type=${this.dataSourceType}`)
        .then((res) => {
          if (!res.data || !Array.isArray(res.data) || res.data.length <= 0) {
            this.$Message.warning("没有数据源可供选择，无法进行探查~");
          }
          this.dataSourceList = res.data.map((item) => ({
              id: `${item.type}@${item.sourceId}`,
              name: item.sourceName,
            }));
        })
        .catch((e) => {
          console.error(e);
        });
    },
    filterTreeByKey() {
      if (!this.searchText) {
        return;
      }
      this.onEnter = true;
      this.isPending = true;
      this.getTableData("queryTable", {
        key: this.searchText,
        leaftype: "table",
      });
    },
    filterTree: debounce(function (query) {
      if (this.onEnter) {
        return;
      }
      query = query.target.value;
      if (query.startsWith("[")) return;
      this.isPending = true;
      this.searchText = query;
      if (query !== "") {
        this.filterList = [];
        this.filterLoading = true;
        this.pageNum = 1;
        this.getTableData("queryOptions", { key: query });
      } else {
        this.filterList = [];
        this.isPending = false;
      }
    }, 500),
    filterTreeByTypeAndId(option) {
      // console.log(option);
      if (!option) {
        return;
      }
      this.isPending = true;
      let { label, value } = option;
      this.searchText = label;
      let [leaftype, id] = value.split("&");
      if (leaftype == "datasource") {
        this.dataSourceId = id;
      }
      this.pageNum = 1;
      this.getTableData("selectOption", { leaftype, id });
    },
    filterTreeByDataSourceId(option) {
      this.isPending = true;
      this.pageNum = 1;
      //this.dataSourceId = id;
      let queryType = option.value=='all'?"init":"selectOption";
      let params = option.value=='all'?{}:{ leaftype: "datasource",id: option.value,};
      this.getTableData(queryType, params);
    },
    // queryTableWithCode() {
    //   let { resType, resIdProp, sqlCode } = this;
    //   if (!sqlCode) {
    //     return;
    //   }
    //   let resTable = resIdProp.split("@");
    //   let tableName = `${resTable[2]}_${resTable[3]}`;
    //   const suffix = {
    //     hive: "hql",
    //     mysql: "jdbc",
    //     rds: "jdbc",
    //     gp: "jdbc",
    //     es: "jdbc",
    //   }[resType];
    //   const filename = `${tableName}_select.${suffix}`;
    //   const md5Path = util.md5(filename);
    //   console.log("add query tab:", sqlCode, filename);
    //   const optionsAdd = {
    //     id: md5Path,
    //     tableId: resIdProp,
    //     filename,
    //     filepath: "",
    //     // saveAs表示临时脚本，需要关闭或保存时另存
    //     saveAs: true,
    //     noLoadCache: true,
    //     code: sqlCode,
    //     sourceId: resTable[1],
    //     tableId: resIdProp,
    //     // type: "createTable",
    //   };
    //   const optionsRun = {
    //     id: md5Path,
    //     tableId: resIdProp,
    //     dataSourceId: `${resTable[0]}@${resTable[1]}`,
    //   };
    //   this.addTabAndRun(optionsAdd, optionsRun);
    //   // this.dispatch("Workbench:add",options,
    //   //   (f) => {
    //   //     if (!f) {q
    //   //       return;
    //   //     }
    //   //     this.$nextTick(() => {
    //   //       this.dispatch("Workbench:run",);
    //   //     });
    //   //   }
    //   // );
    // },
    onClick({ index, item }) {
      this.$refs.contextMenu.close();
      clearTimeout(this.dblClickTimer);
      this.dblClickTimer = setTimeout(() => {
        switch (item.dataType) {
          case "service":
            this.toggleService(item, index);
            break;
          case "db":
            this.toggleDB(item, index);
            break;
          case "tb":
            this.toggleTB(item, index);
            break;
          case "field":
            break;
        }
      }, 300);
    },
    toggleService(item) {
      this.sendTrack([
        { pageId: 22, buttonId: 139, type: "click" },
        { pageId: 22, buttonId: 140, type: "show" },
      ]);
      this.currentAcitved = item;
      this.setHiveCache(this.currentAcitved);
      if (item.children.length) return (item.isOpen = !item.isOpen);
    },
    async toggleDB(item) {
      this.sendTrack([
        { pageId: 22, buttonId: 140, type: "click" },
        { pageId: 22, buttonId: 141, type: "show" },
      ]);
      this.currentAcitved = item;
      this.setHiveCache(this.currentAcitved);
      if (item.children.length) return (item.isOpen = !item.isOpen);
      if (this.isPending)
        return this.$Message.warning(this.$t("message.constants.warning.api"));
      //await this.getTables(item, true);
    },
    async applyRight() {
      this.sendTrack([{ pageId: 22, buttonId: 145, type: "click" }]);
      let data = await this.queryColumns(this.currentAcitved);
      let columnDatas =
        !!data &&
        data.map((n, index) => ({
          name: n.columnName,
          id: n.columnId,
          type: n.columnType,
          _checked: n.acl,
          _disabled: n.acl,
        }));
      this.columnDatas = columnDatas;
      this.$refs.applyRightDialog.open(columnDatas);
    },
    async toggleTB(item) {
      this.currentAcitved = item;
      this.setHiveCache(this.currentAcitved);
      if (item.children.length) return (item.isOpen = !item.isOpen);
      if (this.isPending)
        return this.$Message.warning(this.$t("message.constants.warning.api"));
      await this.getTableColumns(item, true, true);
    },
    getTables(item, isOpen) {
      return new Promise((resolve, reject) => {
        this.isPending = true;
        const url = `/datasource/tables`;
        api
          .fetch(
            url,
            {
              database: item.name,
            },
            "get"
          )
          .then((rst) => {
            this.isPending = false;
            item.isOpen = isOpen;
            this.$set(
              item,
              "children",
              rst.tables.map((table) => {
                return {
                  dbName: item.name,
                  name: table.tableName,
                  value: table.tableName,
                  isAcl: table.isAcl,
                  dataType: "tb",
                  iconCls: "fi-table",
                  isOpen: false,
                  isVisible: true,
                  isView: table.isView,
                  createdBy: table.createdBy,
                  createdAt: table.createdAt,
                  lastAccessAt: table.lastAccessAt,
                  children: [],
                };
              })
            );
            resolve(item);
          })
          .catch((err) => {
            reject(err);
            this.isPending = false;
          });
      });
    },
    asyncGetTableColumns({ item, isOpen, async }, cb) {
      this.getTableColumns(item, isOpen, async).then((item) => {
        cb(item);
      });
    },
    async queryColumns(item) {
      let worspacecId = storage.get(WORKSPACEIDKEY, "cookie");
      let resp = await axios({
        method: "get",
        url: `/api/rest_j/v1/metadata/v1/getAuthResDetailIdByResId?resId=${item.id}&workspace=${worspacecId}`,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        transformRequest: [
          function (data, headers) {
            return JSON.stringify(data);
          },
        ],
      });
      return resp.data;
    },
    async getTableColumns(item, isOpen, async) {
      let data = await this.queryColumns(item);
      let tmpFullColumnString = "";
      let children = [];
      !!data &&
        data.forEach((n, index) => {
          if (index === data.length - 1) {
            tmpFullColumnString += n.columnName;
          } else if (index < length - 1) {
            tmpFullColumnString += `${n.columnName},`;
          }
          children.push({
            name: n.columnName,
            id: n.columnId,
            remark: n.remark,
            dataType: "field",
            isOpen: false,
            isVisible: true,
            iconCls: "fi-field",
            type: n.columnType,
            partitioned: n.isPartition,
            isAcl: n.acl,
            comment: n.columnComment,
          });
        });
      item.isOpen = isOpen;
      this.$set(item, "children", children);
      this.$set(item, "fullColumn", tmpFullColumnString);
    },
    onContextMenu({ ev, item }) {
      this.currentType = item.dataType;
      // 点击表的右键
      if (this.currentType == "tb") {
        this.sendTrack([
          { pageId: 22, buttonId: 141, type: "click" },
          { pageId: 22, buttonId: 142, type: "show" },
          { pageId: 22, buttonId: 143, type: "show" },
          { pageId: 22, buttonId: 144, type: "show" },
          { pageId: 22, buttonId: 145, type: "show" },
          { pageId: 22, buttonId: 146, type: "show" },
          { pageId: 22, buttonId: 147, type: "show" },
          { pageId: 22, buttonId: 148, type: "show" },
          { pageId: 22, buttonId: 149, type: "show" },
        ]);
      }

      this.$refs.contextMenu.open(ev);
      this.currentAcitved = item;
      this.setHiveCache(this.currentAcitved);
    },
    handledbclick({ item }) {
      this.currentAcitved = item;
      this.setHiveCache(this.currentAcitved);
      clearTimeout(this.dblClickTimer);
      this.pasteName();
    },
    copyName() {
      let copyLable = "";
      // console.log(this.currentAcitved);
      switch (this.currentAcitved.dataType) {
        case "tb":
          // copyLable = `${this.currentAcitved.dbName}.${this.currentAcitved.name}`;
          let ids = this.currentAcitved.id&&this.currentAcitved.id.split("@");
          let idLength = ids.length;
          copyLable = `${ids[idLength-2]}.${ids[idLength-1]}`;

          this.sendTrack([{ pageId: 22, buttonId: 146, type: "click" }]);
          break;
        default:
          copyLable = this.currentAcitved.name;
          break;
      }
      // console.log(copyLable);
      util.executeCopy(copyLable);
    },
    async reflesh() {
      if (this.currentType == "tb") {
        this.sendTrack([{ pageId: 22, buttonId: 149, type: "click" }]);
      }
      if (this.isPending)
        return this.$Message.warning(this.$t("message.constants.warning.api"));
      this.initData();
      // if (this.currentAcitved) {
      //   this.currentAcitved.children = [];
      //   if (this.currentAcitved.dataType === "tb") {
      //     // 刷新时候清空下size和partitions，否则刷新后再打开表结构数据就会异常
      //     this.$set(this.currentAcitved, "size", null);
      //     this.$set(this.currentAcitved, "partitions", []);
      //     await this.getTableColumns(this.currentAcitved, true, true);
      //   } else {
      //     await this.getTables(this.currentAcitved, true);
      //     this.$refs.navbar.searchText = "";
      //   }
      // } else {
      //   const cur = storage.get("activedHiveInfo");
      //   if (cur && cur.type === "db") {
      //     this.currentAcitved = this.tableList.find(
      //       (item) => item.name === cur.name
      //     );
      //     await this.getTables(this.currentAcitved, true);
      //   } else {
      //     this.$Message.warning(this.$t("message.database.notPosition"));
      //   }
      // }
    },
    pasteName() {
      /*const value =
        this.currentAcitved.dataType === "tb"
          ? `${this.currentAcitved.dbName}.${this.currentAcitved.name}`
          : this.currentAcitved.name;*/
          let value = this.currentAcitved.name;
          if(this.currentAcitved.dataType === "tb"){
            let ids = this.currentAcitved.id&&this.currentAcitved.id.split("@");
            let idLength = ids.length;
            value = `${ids[idLength-2]}.${ids[idLength-1]}`;
          }
        
      if (this.currentAcitved.dataType === "tb") {
        this.sendTrack([{ pageId: 22, buttonId: 147, type: "click" }]);
      }
      this.dispatch("Workbench:pasteInEditor", value, this.node);
    },
    // initDefaultTab() {
    //   const filename = `新建查询1`;
    //   const md5Path = util.md5(filename);
    //   console.log("add default");
    //   this.dispatch(
    //     "Workbench:add",
    //     {
    //       id: md5Path,
    //       filename,
    //       filepath: "",
    //       // saveAs表示临时脚本，需要关闭或保存时另存
    //       saveAs: true,
    //       noLoadCache: true,
    //       code: "",
    //     },
    //     (f) => {
    //       if (!f) {
    //         return;
    //       }
    //       // this.$nextTick(() => {
    //       //   this.dispatch("Workbench:run", { id: md5Path });
    //       // });
    //     }
    //   );
    // },
    async queryTable() {
      this.sendTrack([{ pageId: 22, buttonId: 142, type: "click" }]);
      // console.log(this.currentAcitved);
      let [type, sourceId, db, table] = this.currentAcitved.id.split("@");
      let tabName = `${db}_${table}`;
      let sql = `select * from ${db}.${table} limit 100`;
      if (type == "hive") {
        let param = {
          type,
          sourceId,
          schema: db,
          env: NODE_ENV == "PROD" ? "pro" : "dev",
          table,
          workspace: storage.get(WORKSPACEIDKEY, "cookie"),
        };
        let { code, data, msg } = await axios({
          method: "POST",
          url: `/api/rest_j/v1/metadata/v1/isExplore`,
          data: param,
        });
        if (code != "0") {
          this.$Message.error({
            duration: 0,
            closable: true,
            content: msg,
          });
          return;
        } else {
          sql = data;
        }
      } else if (type == "es") {
        tabName = table;
        sql = `select * from ${table} limit 100`;
      }
      const suffix = {
        hive: "hql",
        mysql: "jdbc",
        rds: "jdbc",
        gp: "jdbc",
        es: "jdbc",
        clickhouse: "jdbc",
      }[type];
      const filename = `${tabName}_select.${suffix}`;
      const md5Path = util.md5(filename);
      const optionsAdd = {
        id: md5Path,
        tableId: this.currentAcitved.id,
        sourceId: `${sourceId}?${type}@${sourceId}`||null,
        filename,
        filepath: "",
        // saveAs表示临时脚本，需要关闭或保存时另存
        saveAs: true,
        unsave:true,
        ismodifyByOldTab:true,
        noLoadCache: true,
        code: sql,
        // sourceId: this.currentAcitved.sourceId || null,
      };
      const optionsRun = {
        id: md5Path,
        tableId: this.currentAcitved.id,
        dataSourceId: `${type}@${sourceId}`,
      };
      this.addTabAndRun(optionsAdd, optionsRun);
      // this.dispatch("Workbench:add", options, (f) => {
      //   if (!f) {
      //     return;
      //   }
      //   this.$nextTick(() => {
      //     this.dispatch("Workbench:run", {
      //       id: md5Path,
      //       tableId: this.currentAcitved.id,
      //       dataSourceId: `${type}@${sourceId}`,
      //     });
      //   });
      // });
    },
    addTabAndRun(optionsAdd, optionsRun) {
      this.dispatch("Workbench:add", optionsAdd, (f) => {
        if (!f) {
          return;
        }
        this.$nextTick(() => {
          this.dispatch("Workbench:run", optionsRun);
        });
      });
    },
    async describeTable() {
      this.sendTrack([{ pageId: 22, buttonId: 144, type: "click" }]);
      const waitFor = [];
      const params = {
        database: this.currentAcitved.dbName,
        tableName: this.currentAcitved.name,
        id: this.currentAcitved.id,
      };
      waitFor.push(
        this.getTableBaseInfo(params),
        this.getTableFieldsInfo(params),
        // .then(fields => {
        //   this.currentAcitved.fieldsList = fields;
        // }),
        this.getTableStatisticInfo(params)
      );
      if (waitFor.length) {
        Promise.all(waitFor)
          .then(() => {
            const filename = `${this.$t("message.hiveTableDesc.tableDetail")}(${
              this.currentAcitved.name
            })`;
            const md5 = util.md5(filename);
            this.dispatch(
              "Workbench:add",
              {
                id: md5,
                filename,
                filepath: "",
                data: this.currentAcitved,
                type: "tableDetails",
              },
              () => {}
            );
          })
          .catch((e) => {
            console.error(e);
          });
      }
    },
    getTableBaseInfo(params) {
      // return new Promise(resolve => {
      //   api.fetch(`/metadata/v1/getResBaseInfo?resId=${resId}`, "get").then(rst => {
      //     this.currentAcitved.baseInfo = rst.data;
      //     resolve();
      //   });
      // });
      return axios({
        method: "get",
        url: `/api/rest_j/v1/metadata/v1/getResBaseInfo?resId=${this.currentAcitved.id}`,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        transformRequest: [
          function (data, headers) {
            return JSON.stringify(data);
          },
        ],
      }).then(({ code, data, message }) => {
        this.currentAcitved.baseInfo = {
          database: params.database,
          name: params.tableName,
          alias: "",
          partitionName: data.partitionName,
          creator: "",
          createTime: (data.createTime - 0) / 1000,
          latestAccessTime: "",
          comment: data.tableComment,
          lifecycle: "",
          modelLevel: "",
          useWay: "",
          externalUse: "",
          productName: "",
          projectName: data.workspaceName,
          usage: "",
        };
      });
    },
    asyncGetTableFieldsInfo(params, cb) {
      this.getTableFieldsInfo(params)
        .then((fields) => {
          cb(fields);
        })
        .catch((e) => {
          console.error(e);
          cb(false);
        });
    },
    getTableFieldsInfo(params) {
      let { id } = this.$store.state.header.workspace;
      return axios({
        method: "get",
        url: `/api/rest_j/v1/metadata/v1/getAuthResDetailIdByResId?resId=${params.id}&workspace=${id}`,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        transformRequest: [
          function (data, headers) {
            return JSON.stringify(data);
          },
        ],
      }).then(({ code, data, message }) => {
        this.currentAcitved.fieldsList =
          data && Array.isArray(data)
            ? data.map((item) => ({
                name: item.columnName,
                type: item.columnType,
                alias: item.columnName,
                primary: "/",
                partitionField: item.isPartition,
                rule: item.characterMaximumLength || "/",
                comment: item.columnComment,
              }))
            : [];
      });
    },
    getTableStatisticInfo(params) {
      return axios({
        method: "get",
        url: `/api/rest_j/v1/metadata/v1/getResPartition?resId=${this.currentAcitved.id}`,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        transformRequest: [
          function (data, headers) {
            return JSON.stringify(data);
          },
        ],
      }).then(({ code, data, message }) => {
        this.currentAcitved.statisticInfo = {
          fieldsNum: "",
          tableSize: "",
          fileNum: "",
          partitionsNum: "",
          tableLastUpdateTime: "",
        };
      });
      // return new Promise((resolve, reject) => {
      //   api
      //     .fetch("/datasource/getTableStatisticInfo", params, "get")
      //     .then(rst => {
      //       this.currentAcitved.statisticInfo = rst.tableStatisticInfo;
      //       resolve();
      //     })
      //     .catch(err => {
      //       reject(err);
      //     });
      // });
    },
    getTableSize(params) {
      return new Promise((resolve, reject) => {
        api
          .fetch("/datasource/size", params, "get")
          .then((rst) => {
            resolve(rst.sizeInfo.size);
          })
          .catch((err) => {
            reject(err);
            console.error(err);
          });
      });
    },
    async copyAllColumns() {
      this.sendTrack([{ pageId: 22, buttonId: 148, type: "click" }]);
      if (!this.currentAcitved.fullColumn) {
        await this.getTableColumns(this.currentAcitved, false, false);
      }
      util.executeCopy(this.currentAcitved.fullColumn);
    },
    openDeleteDialog() {
      this.sendTrack([{ pageId: 22, buttonId: 143, type: "click" }]);
      const type = this.currentAcitved.isView ? "视图" : "表";
      this.$refs.deleteDialog.open({
        type,
        name: this.currentAcitved.name,
      });
    },
    deleteTable() {
      this.isDeleting = true;
      const tableName = `${this.currentAcitved.dbName}.${this.currentAcitved.name}`;
      const code = this.currentAcitved.isView
        ? `drop view ${tableName};`
        : `drop table ${tableName};`;
      const filename = `${tableName}_drop.hql`;
      const md5Path = util.md5(filename);
      this.dispatch(
        "Workbench:add",
        {
          id: md5Path,
          filename,
          filepath: "",
          saveAs: true,
          noLoadCache: true,
          // type: 'backgroundScript',
          code,
        },
        (f) => {
          if (!f) {
            this.isDeleting = false;
            return this.$refs.deleteDialog.close();
          }
          this.isDeleting = false;
          this.$refs.deleteDialog.close();
          this.$nextTick(() => {
            this.dispatch(
              "Workbench:run",
              {
                id: md5Path,
                dataSourceId: this.currentAcitved.id.substr(
                  0,
                  this.currentAcitved.id.lastIndexOf("@")
                ),
              },
              () => {
                // 由于删除表成功之后，currentAcitved指向为当前已被删除的表，所以要改为刷新库
                this.currentAcitved = find(
                  this.tableList,
                  (db) =>
                    db.name === this.currentAcitved.dbName ||
                    this.currentAcitved.name
                );
                this.setHiveCache(this.currentAcitved);
                this.reflesh();
              }
            );
          });
        }
      );
    },
    openExportDialog(type) {
      if (type === "out") {
        this.currentAcitved = null;
        this.setHiveCache(this.currentAcitved);
      }
      this.filterDbList = this.filterDatabase();
      this.$refs.exportDialog.open();
    },
    setSearchText(value) {
      if (this.isPending)
        return this.$Message.warning(this.$t("message.constants.warning.api"));
      this.searchText = value;
    },
    getPartitions(tableInfo, cb) {
      const Acitvedtable = tableInfo || this.currentAcitved;
      const url = `/datasource/partitions`;
      api
        .fetch(
          url,
          {
            database: Acitvedtable.dbName,
            table: Acitvedtable.name,
          },
          "get"
        )
        .then((rst) => {
          const isPartMore =
            rst.partitionInfo.partitions &&
            !isEmpty(rst.partitionInfo.partitions[0].children);
          const partitions = this.formatPartions(rst.partitionInfo.partitions);
          this.$set(Acitvedtable, "isPartition", rst.partitionInfo.isPartition);
          this.$set(Acitvedtable, "isPartMore", isPartMore);
          this.$set(Acitvedtable, "partitions", partitions);
          if (cb) {
            cb({
              isPartition: rst.partitionInfo.isPartition,
              isPartMore,
              partitions,
            });
          }
        });
    },
    getPartitionsSize(params, cb) {
      // cloneDeep是因为值会发生改变。
      const originPart = cloneDeep(params.partition);
      const currentdb = find(
        this.tableList,
        (db) => db.name === params.database
      );
      this.currentAcitved = find(
        currentdb.children,
        (tb) => tb.name === params.table
      );
      this.setHiveCache(this.currentAcitved);
      if (params.partition) {
        this.$set(params, "partition", this.getDeepPath(params.partition));
      }
      api.fetch("/datasource/size", params, "get").then((rst) => {
        const size = rst.sizeInfo.size;
        if (!params.partition) {
          this.currentAcitved.size = size;
        } else {
          const findPart = find(
            this.currentAcitved.partitions,
            (item) => item.path === originPart.path
          );
          findPart.size = size;
        }
        cb(rst.sizeInfo.size);
      });
    },
    getPartitionsSizeByOuter(tbInfo, cb) {
      const params = {
        database: tbInfo.dbName,
        table: tbInfo.name,
        partition: tbInfo.partNode
          ? this.getDeepPath(tbInfo.partNode)
          : tbInfo.partNode,
      };
      api.fetch("/datasource/size", params, "get").then((rst) => {
        cb(rst.sizeInfo.size);
      });
    },
    setPartitionsTitle(node, size) {
      node.title += `(分区大小：${size})`;
    },
    // 分区名称在后台存储是以name1/name2/name3的方式
    // 返回前台是{path:name1, children:[{path:name1/name2}]}，所以通过这个函数拿到最底层的path
    getDeepPath(node) {
      if (isEmpty(node.children)) return node.path;
      for (let i = 0; i < node.children.length; i++) {
        return this.getDeepPath(node.children[i]);
      }
    },
    // 对partition进行格式化成tree组件需要的格式
    formatPartions(part) {
      return map(part, (o) => {
        return {
          label: o.label,
          title: o.label,
          expand: false,
          children: this.formatPartions(o.children),
          path: o.path,
        };
      });
    },
    filterDatabase(dbList) {
      return dbList || this.tableList;
    },
    "HiveSidebar:getDatabase"(option, cb) {
      this.initData().then((dbList) => {
        cb(this.filterDatabase(dbList));
      });
    },
    "HiveSidebar:getTables"(option, cb) {
      this.getTables(option.item, false).then((item) => {
        cb(item.children);
      });
    },
    "HiveSidebar:getTablePartitions"(option, cb) {
      this.getPartitions(option.item, (item) => {
        cb(item);
      });
    },
    "HiveSidebar:deletedAndRefresh"() {
      // 由于删除表成功之后，currentAcitved指向为当前已被删除的表，所以要改为刷新库
      this.currentAcitved = find(
        this.tableList,
        (db) =>
          db.name === this.currentAcitved.dbName || this.currentAcitved.name
      );
      this.setHiveCache(this.currentAcitved);
      this.reflesh();
    },
    getFileTree(type) {
      const method =
        type === "share" ? "WorkSidebar:showTree" : "HdfsSidebar:showTree";
      const treeType = type === "share" ? "scriptTree" : "hdfsTree";
      const tmpTree = storage.get(treeType, "SESSION");
      if (!tmpTree || isEmpty(tmpTree)) {
        this.fileTree = [];
        this.dispatch(method, (f) => {
          f.getRootPath(() => {
            f.getTree((tree) => {
              if (tree) {
                this.fileTree.push(tree);
              }
              this.loadDataFn = f.loadDataFn;
            });
          });
        });
      } else {
        this.fileTree = cloneDeep(tmpTree);
        this.dispatch(method, (f) => {
          this.loadDataFn = f.loadDataFn;
        });
      }
    },
    // 过滤文件夹
    filterNode(node) {
      return !node.isLeaf;
    },
    exportTable(one, two, columns) {
      const part = one.partitions.split("=");
      let separator = one.separator;
      if (one.separator === "%20") {
        separator = " ";
      } else if (one.separator === "\\t") {
        separator = "\t";
      }
      // 路径最后一个字符可能是/,会导致拼接错误
      const lastParam =
        two.path.lastIndexOf("/") + 1 === two.path.length
          ? two.path.length - 1
          : two.path.length;
      const path = two.path.slice(7, lastParam);
      const dataInfo = {
        database: one.dbName,
        tableName: one.tbName,
        isPartition: one.isPartition,
        partition: part[0],
        partitionValue: part[1],
        columns,
      };
      const destination = {
        path: `${path}/${two.fileName}.${one.exportType}`,
        pathType: two.type,
        hasHeader: one.isHasHeader,
        isCsv: one.exportType === "csv",
        isOverwrite: one.isOverwrite !== "追加",
        fieldDelimiter: separator,
        sheetName: two.sheetName || one.tbName,
        encoding: one.exportType === "csv" ? one.chartset : "",
        nullValue: one.nullValue,
      };
      if (destination.isCsv) {
        delete destination.sheetName;
      } else {
        delete destination.isOverwrite;
        delete destination.fieldDelimiter;
      }
      const tabName = `export__${this.currentAcitved.dbName}.${this.currentAcitved.name}`;
      const code = `val destination = """${JSON.stringify(
        destination
      )}"""\nval dataInfo = """${JSON.stringify(
        dataInfo
      )}"""\ncom.webank.bdp.dataworkcloud.engine.imexport.ExportData.exportData(spark,dataInfo,destination)`;
      const md5Path = util.md5(tabName);
      this.dispatch(
        "Workbench:add",
        {
          id: md5Path,
          filename: tabName + ".scala",
          filepath: "",
          // saveAs表示临时脚本，需要关闭或保存时另存
          saveAs: true,
          noLoadCache: true,
          code,
        },
        (f) => {
          if (!f) {
            return this.$refs.exportDialog.close();
          }
          this.$refs.exportDialog.close();
          this.$nextTick(() => {
            this.dispatch(
              "Workbench:run",
              {
                id: md5Path,
                type: "storage",
                executionCode: {
                  dataInfo,
                  destination,
                },
                backgroundType: "export",
              },
              () => {
                this.$refs.exportDialog.loading = false;
              }
            );
          });
        }
      );
    },
    openAddTab() {
      const filename = `${this.$t(
        "message.newNavBar.createdTitle"
      )}_${new Date().getTime()}`;
      const md5 = util.md5(filename);
      this.dispatch(
        "Workbench:add",
        {
          id: md5,
          filename,
          filepath: "",
          data: this.tableList,
          type: "createTable",
        },
        () => {}
      );
    },
    setHiveCache(cur) {
      let item = null;
      if (cur) {
        item = {
          name: cur.name,
          type: cur.dataType,
        };
      }
      storage.set("activedHiveInfo", item);
    },
  },
};
</script>
<style src="@dss/assets/styles/sidebar.scss" lang="scss">
</style>
<style lang="scss" scoped>
  ::v-deep .ivu-scroll-wrapper{
    height:100%;
  }
  ::v-deep .ivu-scroll-container{
    height:calc(100% - 120px)!important;
  }
</style>

